import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ArrowDownIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="10px"
          height="15px"
          viewBox="0 0 10 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon
              id="arrowDownIcon"
              points="12.8203125 5 12.8203125 16.796875 15.828125 13.828125 17 15 12 20 7 15 8.171875 13.828125 11.1796875 16.796875 11.1796875 5"
            ></polygon>
          </defs>
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-851.000000, -1195.000000)"
            >
              <g id="General-Icons" transform="translate(56.000000, 753.000000)">
                <g id="row" transform="translate(0.000000, 399.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="general-/-arrow-down-/-Default"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#path-1"></use>
                      </mask>
                      <use
                        id="arrow-down"
                        fill="currentColor"
                        xlinkHref="#arrowDownIcon"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

ArrowDownIcon.propTypes = {
  className: PropTypes.string,
};

export default ArrowDownIcon;
